module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(!_vm.hideImage) ? _c('v-img', {
    staticClass: "mb-1",
    attrs: {
      "src": '/static/calendarEventImages/img_planmyday_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text hidden-xs-only"
  }, [_vm._v("Veranstaltungen")])], 1) : _c('v-card-title', {
    staticClass: "hidden-xs-only"
  }, [_vm._v("Veranstaltungen")]), _vm._v(" "), (_vm.$vars.loading) ? _c('v-skeleton-loader', {
    ref: "skeleton",
    staticClass: "mx-auto",
    attrs: {
      "type": "list-item-avatar-two-line"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [(Object.keys(_vm.veranstaltungen).length == 0) ? _c('v-subheader', {
    staticClass: "justify-center"
  }, [_vm._v("\n      Keine Veranstaltungen geplant.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.veranstaltungen), function(veranstaltung, monat) {
    return _c('span', {
      key: monat
    }, [_c('v-subheader', {
      staticClass: "justify-center title"
    }, [_vm._v(_vm._s(_vm.$filters.date(monat, "MMM")))]), _vm._v(" "), _vm._l((veranstaltung), function(item, index) {
      return _c('v-list-item', {
        key: index,
        staticClass: "mx-2 pa-1 rounded-lg",
        on: {
          "click": function($event) {
            _vm.veranstaltungDialog = true;
            _vm.selectedEvent = item;
          }
        }
      }, [_c('v-list-item-action', {
        staticClass: "mx-0 px-2 justify-center align-start",
        staticStyle: {
          "width": "60px"
        }
      }, [_c('div', {
        staticClass: "text-center"
      }, [_c('div', {
        staticClass: "title font-weight-bold"
      }, [_vm._v(_vm._s(_vm.$filters.date(item.vonDatum, "DD.")))]), _vm._v(" "), _c('div', {
        staticClass: "caption"
      }, [_vm._v(_vm._s(_vm.$filters.date(item.vonDatum, "MMM")))])])]), _vm._v(" "), _c('v-divider', {
        attrs: {
          "vertical": ""
        }
      }), _vm._v(" "), _c('v-list-item-content', {
        staticClass: "pl-2"
      }, [_c('div', {
        staticClass: "d-flex"
      }, [_c('span', {
        staticClass: "d-flex align-center mr-2"
      }, [(item.anmeldungen.includes(_vm.currentBbr)) ? _c('v-icon', {
        staticClass: "green--text",
        attrs: {
          "small": ""
        }
      }, [_vm._v("check_circle")]) : _c('v-icon', {
        staticClass: "grey--text",
        attrs: {
          "small": ""
        }
      }, [_vm._v("help")])], 1), _vm._v(" "), _c('span', {
        staticClass: "text-body-2 font-weight-medium"
      }, [_vm._v("\n              " + _vm._s(item.titel) + "\n            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("access_time")]), _vm._v(_vm._s(item.vonZeit) + " Uhr\n          ")], 1), _vm._v(" "), _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("group")]), _vm._v(_vm._s(item.anmeldungen.length + item.weitereAnmeldungen.length) + " Zusage"), (item.anmeldungen.length + item.weitereAnmeldungen.length !== 1) ? _c('span', [_vm._v("n")]) : _vm._e()], 1), _vm._v(" "), (item.kalender !== 'Ripuaria') ? _c('v-list-item-subtitle', [_c('v-icon', {
        staticClass: "pr-2 hidden-xs-only",
        attrs: {
          "small": ""
        }
      }, [_vm._v("calendar_month")]), _vm._v(_vm._s(item.kalender) + "\n          ")], 1) : _vm._e()], 1), _vm._v(" "), (
        item.anmeldungBis &&
        (new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24 < 7 &&
        (new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24 > 0
      ) ? _c('v-list-item-action', {
        staticClass: "text-center"
      }, [_c('v-tooltip', {
        attrs: {
          "bottom": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('span', _vm._g({
              staticClass: "caption"
            }, on), [_c('v-icon', {
              attrs: {
                "small": ""
              }
            }, [_vm._v("alarm")]), _c('br'), _vm._v(_vm._s((new Date(item.anmeldungBis).getTime() - new Date(_vm.datum).getTime()) / 1000 / 60 / 60 / 24) + "\n                Tage")], 1)]
          }
        }], null, true)
      }, [_vm._v(" "), _c('span', [_vm._v("Anmeldefrist")])])], 1) : _vm._e()], 1)
    })], 2)
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "hidden-xs-only"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "to": "./veranstaltungen",
      "text": ""
    }
  }, [_vm._v("Alle Veranstaltungen")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('dialogVeranstaltung', {
    attrs: {
      "visible": _vm.veranstaltungDialog,
      "selectedEvent": _vm.selectedEvent
    },
    on: {
      "update:visible": function($event) {
        _vm.veranstaltungDialog = $event
      },
      "close": function($event) {
        _vm.veranstaltungDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c895b110"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/veranstaltungenListe.vue
// module id = 811
// module chunks = 15